<template>
  <div>
    <el-table :data="items">
      <el-table-column align="left" label="复合片" prop="pdc.name">
        <template slot-scope="scope">
          {{ scope.row.pdc.name }} （{{
            scope.row.category == 2 ? '旧' : '新'
          }}）
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="数量"
        prop="number"
      ></el-table-column>
      <el-table-column align="center" label="钻头">
        <template slot-scope="scope">
          <div
            v-for="no in scope.row.drill_serial_numbers.split(',')"
            :key="no"
            v-if="scope.row.drill_serial_numbers"
          >
            <DrillLink :no="no"></DrillLink>
          </div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="状态">
        <template slot-scope="scope">
          <span
            class="label"
            :class="scope.row.status == 1 ? 'label-warning' : 'label-success'"
          >
            {{ scope.row.status == 1 ? '未出库' : '已出库' }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="备注"
        prop="remark"
      ></el-table-column>
      <el-table-column label="出库时间" align="center">
        <template slot-scope="scope">
          {{
            scope.row.confirm_time
              ? $time(scope.row.confirm_time).format('YYYY-MM-DD')
              : '-'
          }}
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" min-width="120">
        <template slot-scope="scope">
          <template v-if="scope.row.status == 1">
            <template v-if="admin">
              <btn-tag
                :btn="true"
                text="编辑"
                :key="Math.random()"
                :auth-id="51201"
                module-name="stock"
                @click.native="editItem(scope.row, scope.$index)"
              ></btn-tag>
              <btn-tag
                :btn="true"
                text="删除"
                :key="Math.random()"
                :auth-id="51201"
                module-name="stock"
                btn-class="btn-danger"
                @click.native="hanldeDelte(scope.row, scope.$index)"
              ></btn-tag>
              <btn-tag
                :btn="true"
                text="确认出库"
                :key="Math.random()"
                :auth-id="51201"
                module-name="stock"
                btn-class="btn-warning"
                @click.native="hanldeConfirmStockOut(scope.row, scope.$index)"
              ></btn-tag> </template
          ></template>
          <template v-else>
            <button
              v-if="scope.row.logistic_number"
              class="btn btn-sm btn-labeled btn-rounded btn-default"
              @click="drillDeliveryDetail(scope.row)"
            >
              物流信息
            </button>
            <btn-tag
              :btn="true"
              text="详情"
              :key="Math.random()"
              :auth-id="51201"
              module-name="stock"
              @click.native="handleShow(scope.row)"
            ></btn-tag>
          </template>
        </template>
      </el-table-column>
    </el-table>

    <pdc-out-former
      :model="model"
      :show.sync="formerVisible"
      @updated="updatedCallback"
    ></pdc-out-former>
    <item-detail :model="model" :show.sync="detailVisible"></item-detail>
    <delivery-info
      :model="model"
      :show.sync="formerDeliveryVisible"
    ></delivery-info>
  </div>
</template>

<script>
import { pdcOutRecordDelete, pdcOutRecordConfirm } from '@/service/getData'
import PdcOutFormer from '@/components/pdc_out_former'
import ItemDetail from '@/components/pdc_out_record_detail'
import DeliveryInfo from '@/components/delivery_info'
import { deepClone } from '@/utils'

export default {
  components: {
    PdcOutFormer,
    ItemDetail,
    DeliveryInfo,
  },
  props: {
    admin: false,
    items: null,
  },
  data() {
    return {
      model: {
        id: 0,
        pdc_id: '',
        number: 1,
        stock_out_category: 1,
        drills: null,
        logistic_company: '',
        logistic_number: '',
        receiver_mobile: '',
        remark: '',
      },
      formerVisible: false,
      detailVisible: false,
      formerDeliveryVisible: false,
      editIndex: 0,
    }
  },
  methods: {
    handleShow(item) {
      this.model = item
      this.detailVisible = true
    },
    editItem(item, index) {
      this.editIndex = index
      this.formerVisible = true

      let drills = []
      if (item.drill_serial_numbers) {
        drills = item.drill_serial_numbers.split(',') || []
      }

      this.$nextTick(() => {
        this.model = {
          id: item.id,
          pdc_id: item.pdc_id,
          number: item.number,
          stock_out_category: 1,
          drills: drills,
          logistic_company: item.logistic_company,
          logistic_number: item.logistic_number,
          receiver_mobile: item.receiver_mobile,
          remark: item.remark,
        }
      })
    },
    drillDeliveryDetail(item) {
      this.model = item
      this.formerDeliveryVisible = true
    },
    updatedCallback(data) {
      this.$set(this.items, this.editIndex, data)
    },

    hanldeConfirmStockOut(item, index) {
      let that = this
      this.$confirm('确认出库吗?', '操作提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          let res = await pdcOutRecordConfirm(item.id)
          if (res.status == 0) {
            that.$set(that.items, index, res.data)
          }
        })
        .catch(() => {})
    },

    hanldeDelte(item, index) {
      let that = this
      that.$dialog.confirm('确认删除吗').then(function (dialog) {
        pdcOutRecordDelete(item.id).then((res) => {
          if (res.status == 0) {
            that.items.splice(index, 1)
          }
        })
      })
    },
  },
}
</script>